export default "__VITE_ASSET__46f0c26f__"